import { NextPage } from 'next';

import SsoSelfJoinRedirect from '../components/_organisms/Auth/SsoSelfJoinRedirect';
import { ssoSelfJoinServerSideProps } from '../utils/ssoSelfJoinSsr';

const FeideLogin: NextPage = () => <SsoSelfJoinRedirect newProvider="feide" />;

export const getServerSideProps = ssoSelfJoinServerSideProps;

export default FeideLogin;
